
export default new VueRouter({
  // base: '/mergepc/',
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/page/home/home'),
    meta: {
      title: '首页',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/digital',
    name: 'digital',
    component: () => import('@/page/digital/digital'),
    meta: {
      title: '数字云图',
      //keepAlive: true,
      //showTabbar:true
    }
  },
  {
    path: '/job',
    name: 'job',
    component: () => import('@/page/job/job'),
    meta: {
      title: '求职招聘',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/jobList',
    name: 'jobList',
    component: () => import('@/page/job/job'),
    meta: {
      title: '求职招聘',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/jobwindow',
    name: 'jobwindow',
    component: () => import('@/page/job/Jobwindow'),
    meta: {
      title: '求职招聘',
      keepAlive: false,
      showTabbar:false
    }
  },
  {
    path: '/jobDetails',
    name: 'jobDetails',
    component: () => import('@/page/job/jobDetails'),
    meta: {
      title: '职位详情',
      keepAlive: false,
      showTabbar:true
    }
  },
  {
    path: '/companyDetails',
    name: 'companyDetails',
    component: () => import('@/page/job/companyDetails'),
    meta: {
      title: '公司详情',
      keepAlive: false,
      showTabbar:true
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/page/news/news'),
    meta: {
      title: '新闻资讯',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/page/news/newsDetails'),
    meta: {
      title: '资讯详情',
      keepAlive: false,
      showTabbar:true
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/page/policy/policy'),
    meta: {
      title: '政策法规',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/policyDetails',
    name: 'policyDetails',
    component: () => import('@/page/policy/policyDetails'),
    meta: {
      title: '政策法规详情',
      keepAlive: false,
      showTabbar:true
    }
  },
  {
    path: '/sxActivity',
    name: 'sxActivity',
    component: () => import('@/page/activity/sxActivity'),
    meta: {
      title: '迎新春招聘行动',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/sdActivity',
    name: 'sdActivity',
    component: () => import('@/page/activity/sdActivity'),
    meta: {
      title: '云端送岗进军营',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/page/aboutUs'),
    meta: {
      title: '关于我们',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/scActivity',
    name: 'scActivity',
    component: () => import('@/page/activity/scActivity'),
    meta: {
      title: '四川招聘会',
      keepAlive: true,
      showTabbar:true
    }
  },
  {
    path: '/businessLicense',
    name: 'businessLicense',
    component: () => import('@/page/credentials/businessLicense'),
    meta: {
      title: '营业执照',
      keepAlive: true,
      showTabbar:false
    }
  },
  {
    path: '/humanLicense',
    name: 'humanLicense',
    component: () => import('@/page/credentials/humanLicense'),
    meta: {
      title: '人力资源服务许可证',
      keepAlive: false,
      showTabbar:false
    }
  },
  {
    path: '/legalstatement',
    name: 'legalstatement',
    component: () => import('@/page/credentials/legalStatement'),
    meta: {
      title: '法律声明',
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/useragreement',
    name: 'useragreement',
    component: () => import('@/page/credentials/userAgreement'),
    meta: {
      title: '用户协议',
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/userprivacyagreement',
    name: 'userprivacyagreement',
    component: () => import('@/page/credentials/userPrivacyAgreement'),
    meta: {
      title: '查看详情',
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/page/Signup-shanxi/Signup.vue'),
    meta: {
      title: '山西报名',
      keepAlive: false,
      showTabbar: false
    }
  },{
    path: '/sxZphActivity',
    name: 'sxZphActivity',
    component: () => import('@/page/activity/sxZphActivity'),
    meta: {
      title: '山西省退役军人招聘月启动暨现场招聘会',
      keepAlive: true,
      showTabbar: true
    }
  },{
    path: '/nmDataView',
    name: 'nmDataView',
    component: () => import('@/page/activity/nmDataView'),
    meta: {
      title: "戎归北疆   “职”等你来",
      keepAlive: false,
      showTabbar: false
    }
  },{
    path: '/stopService',
    name: 'stopService',
    component: () => import('@/page/stopService'),
    meta: {
      keepAlive: false,
      title: '服务已停止' 
    }
  },{
    path: '/video/:videoUrl/:poster',
    name: 'video',
    component: () => import('@/page/video'),
    meta: {
      keepAlive: false,
      title: ''
    }
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js